import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProductViewService } from './../../shared/services/product-view.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { AuthService } from "modules/app/services/auth.service";

@Injectable()
export class TeacherProductViewResolverService  {
    constructor(
        private productViewService: ProductViewService,
        private appHelperService: AppHelperService,
        private authService: AuthService
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
        const spaceId = route.params.spaceId;
        const productCode = route.params.productCode;
        const classId = route.params.classId;
        return this.productViewService.getProductDataForTeacher(spaceId, productCode,classId).toPromise().then( (productData) => {
            if (productData && productData.success === false) {
                this.appHelperService.showLoaderAndNavigateToDashboard();
                return;
            }

            // NEMO-6677 : navigate away to dashboard as the product is suppressed.
            let bundleDetails = productData['bundleDetails'];
            let product = bundleDetails && bundleDetails.products && bundleDetails.products.find((bundle) => bundle['dls-product'] && bundle['dls-product'].code === productCode);
            let suppressed = this.appHelperService.isProductSuppressed(product, 'hide-learning-path', spaceId);
    
            if (suppressed) {
                this.appHelperService.navigateToDashboardApp([]);
            }

            return  productData;
        });
    }

}